// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2G2hw","row":"styles_row__3ixyK"};